import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ErrorBoundary } from "react-error-boundary";
import { createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router";

import GlobalError from "@/components/layout/global-error";
import { TiltifyConfigProvider } from "@/context/TiltifyConfigProvider";
import { TwitchConfigProvider } from "@/context/TwitchConfigProvider";
import buildRoutes from "./routes/routes";

const queryClient = new QueryClient();

const appRouter = createBrowserRouter(createRoutesFromElements(buildRoutes()));

export function App() {
  return (
    <ErrorBoundary FallbackComponent={GlobalError}>
      <TiltifyConfigProvider>
        <TwitchConfigProvider>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={appRouter} />
          </QueryClientProvider>
        </TwitchConfigProvider>
      </TiltifyConfigProvider>
    </ErrorBoundary>
  );
}
